/** Quel che serve per contare i giorni: una fattura da passare o un acconto da fatturare a mano. */
export function urgenzaFatture(coda: { giorni_di_attesa: number }[]): string | undefined {
  if (coda.length === 0) return undefined;
  const attesa = Math.max(...coda.map((fattura) => fattura.giorni_di_attesa));
  const giorni = 12 - attesa;
  const soggetto = coda.length === 1 ? "la fattura" : "la prima";
  let termine: string;
  if (giorni < 0) {
    const ritardo = -giorni;
    termine = `${soggetto} è scaduta da ${ritardo} ${ritardo === 1 ? "giorno" : "giorni"}`;
  } else if (giorni === 0) {
    termine = `${soggetto} scade oggi`;
  } else if (giorni === 1) {
    termine = `${soggetto} scade domani`;
  } else {
    termine = `${soggetto} scade fra ${giorni} giorni`;
  }
  return `${coda.length} ${coda.length === 1 ? "fattura" : "fatture"} da passare a Fatture Smart: ${termine}.`;
}
